import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Trash2 } from "lucide-react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

interface RoutineHeaderProps {
  name: string;
  isEditing: boolean;
  routineName: string;
  onEditStart: () => void;
  onEditCancel: () => void;
  onNameChange: (name: string) => void;
  onUpdateName: () => void;
  onDelete: () => void;
}

export const RoutineHeader = ({
  name,
  isEditing,
  routineName,
  onEditStart,
  onEditCancel,
  onNameChange,
  onUpdateName,
  onDelete,
}: RoutineHeaderProps) => {
  const [isRotating, setIsRotating] = useState(false);

  const handleDelete = () => {
    setIsRotating(true);
    onDelete();
    setTimeout(() => setIsRotating(false), 500); // Reset after animation
  };

  return (
    <div className="flex items-center justify-between w-full">
      <div className="flex items-center gap-4">
        {isEditing ? (
          <div className="flex gap-2">
            <Input
              value={routineName}
              onChange={(e) => onNameChange(e.target.value)}
              className="bg-white/10 border-white/20 text-white"
            />
            <Button 
              onClick={onUpdateName}
              className="bg-clubbers-red hover:bg-clubbers-red/80"
            >
              Guardar
            </Button>
            <Button 
              variant="outline" 
              onClick={onEditCancel}
              className="border-white/20 hover:bg-white/10"
            >
              Cancelar
            </Button>
          </div>
        ) : (
          <span 
            onClick={onEditStart}
            className="text-lg sm:text-xl font-heading cursor-pointer hover:text-clubbers-red transition-colors"
          >
            {name}
          </span>
        )}
        <AlertDialog>
          <AlertDialogTrigger asChild>
            <Button
              variant="outline"
              size="icon"
              className={`border-white/20 hover:bg-white/10 transition-transform ${isRotating ? 'animate-[spin_0.5s_ease-in-out]' : ''}`}
            >
              <Trash2 className="h-4 w-4 text-clubbers-red" />
            </Button>
          </AlertDialogTrigger>
          <AlertDialogContent>
            <AlertDialogHeader>
              <AlertDialogTitle>¿Estás seguro?</AlertDialogTitle>
              <AlertDialogDescription>
                Esta acción no se puede deshacer. Se eliminarán todos los ejercicios asociados a esta rutina.
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel>Cancelar</AlertDialogCancel>
              <AlertDialogAction
                onClick={handleDelete}
                className="bg-clubbers-red hover:bg-clubbers-red/90"
              >
                Eliminar
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      </div>
    </div>
  );
};